var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 232,
    height: 232,
    rx: 13,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.6614 96.3636H112.786V185H143.144V96.3636H177.269V71.5455H78.6614V96.3636Z",
    fill: "#6415FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgGroup",
    strokeLinecap: "round",
    fillRule: "evenodd",
    fontSize: "9pt",
    stroke: "#fcfcf9",
    strokeWidth: "0.25mm",
    fill: "#6415ff",
    style: {
      stroke: "#fcfcf9",
      strokeWidth: "0.25mm",
      fill: "#6415ff"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 6.3 18 L 1 7.3 Q 5.7 4.3 11 2.15 Q 16.3 0 21.6 0 Q 24.152 0 25.76 0.826 A 4.662 4.662 0 0 1 27.8 2.8 A 12.425 12.425 0 0 1 29.08 6.637 A 16.665 16.665 0 0 1 29.3 9.4 Q 29.3 10.682 28.931 13.186 A 86.486 86.486 0 0 1 28.65 14.95 Q 28.091 18.259 27.311 22.417 A 615.618 615.618 0 0 1 27.05 23.8 Q 26.1 28.8 25.1 34 L 47.5 34 Q 48.1 30.5 48.85 26.5 Q 49.6 22.5 50.4 18 L 45.1 7.3 Q 49.8 4.3 55.1 2.15 A 28.886 28.886 0 0 1 62.884 0.152 A 26.263 26.263 0 0 1 65.7 0 Q 68.252 0 69.86 0.826 A 4.662 4.662 0 0 1 71.9 2.8 A 12.425 12.425 0 0 1 73.18 6.637 A 16.665 16.665 0 0 1 73.4 9.4 Q 73.4 10.607 73.087 12.921 A 84.949 84.949 0 0 1 72.85 14.55 Q 72.3 18.1 71.4 22.75 Q 70.5 27.4 69.55 32.45 A 7716.485 7716.485 0 0 1 67.926 41.058 A 7031.216 7031.216 0 0 1 67.7 42.25 Q 66.8 47 66.25 50.65 Q 65.7 54.3 65.7 56.2 A 57.859 57.859 0 0 0 65.805 59.8 Q 65.981 62.613 66.45 64.8 Q 67.147 68.054 68.493 70.357 A 13.411 13.411 0 0 0 68.7 70.7 A 24.275 24.275 0 0 1 63.47 73.737 A 18.518 18.518 0 0 1 56.3 75.2 Q 52.162 75.2 49.53 73.732 A 8.091 8.091 0 0 1 46.85 71.35 A 12.425 12.425 0 0 1 45.188 67.949 Q 44.168 64.815 44.104 60.307 A 42.942 42.942 0 0 1 44.1 59.7 A 39.105 39.105 0 0 1 44.145 57.899 Q 44.185 57.03 44.262 56.042 A 87.523 87.523 0 0 1 44.45 53.95 A 124.629 124.629 0 0 1 44.762 51.201 Q 44.912 49.988 45.097 48.663 A 221.386 221.386 0 0 1 45.5 45.9 L 22.9 45.9 Q 22.3 49.3 21.95 52.05 Q 21.667 54.277 21.613 55.618 A 14.562 14.562 0 0 0 21.6 56.2 A 57.859 57.859 0 0 0 21.705 59.8 Q 21.881 62.613 22.35 64.8 Q 23.047 68.054 24.393 70.357 A 13.411 13.411 0 0 0 24.6 70.7 A 24.275 24.275 0 0 1 19.37 73.737 A 18.518 18.518 0 0 1 12.2 75.2 Q 8.062 75.2 5.43 73.732 A 8.091 8.091 0 0 1 2.75 71.35 A 12.425 12.425 0 0 1 1.088 67.949 Q 0.068 64.815 0.004 60.307 A 42.942 42.942 0 0 1 0 59.7 Q 0 54.7 1.65 44.65 Q 3.126 35.66 5.682 21.429 A 3264.727 3264.727 0 0 1 6.3 18 Z",
    vectorEffect: "non-scaling-stroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.bd03d0e953f08720fc55991395f0247f.svg";
export { ForwardRef as ReactComponent };